<template>
  <div id="app">
    <div>
      <div
        v-if="$route.path != '/reports' && $route.path != '/'"
        class="d-flex bgNavbarHeader justify-content-md-normal"
      >
        <p
          class="backBtnContainer ml-2 ml-md-1 mt-1"
          @click="$router.go(-1)"
          v-if="$route.path !== '/' && $route.path != '/AnalyticsSection'"
        >
          <img
            src="@/assets/img/icons/back-arrow.svg"
            alt=""
            class="w-100 h-100"
          />
        </p>
        <div v-else class="pl-2">
          <img
            v-b-toggle.sidebar-1
            alt="Menu"
            class="ham_icon"
            src="@/assets/img/hamburger-menu.png"
          />
          <b-sidebar id="sidebar-1" title="" shadow>
            <div class="px-3 py-2 sub_menu">
              <p @click="homePage()"> Home </p>
              <p
                @click="analytictPage()"
                :style="$route.path == '/AnalyticsSection' ? 'color:red' : ''"
              >
                Analytics Reports
              </p>
            </div>
          </b-sidebar>
        </div>
       
        <p
          class="text-center text-light my-0 module_name_container mx-auto mt-1"
          >{{ $route.meta.subName }}</p
        >

        <img style="margin-right: 40px; height: 25px;" src="@/assets/img/icons/home.svg" alt=""
        @click="analytictPage()"
        >
      </div>
      <router-view />
    </div>
    <!-- <div v-else>
      <connectionLost />
    </div> -->
  </div>
</template>

<script>
  import Loader from "@/components/Partials/loader.vue";
  import connectionLost from "@/components/Partials/connection-lost.vue";
  import Modal from "@/components/Partials/globalModal.vue";
  import navLists from "@/helper/navLists";
  import MasterService from "@/services/MasterService";
  export default {
    name: "App",
    components: {
      Loader,
      Modal,
      connectionLost,
    },
    data() {
      return {
        onLine: navigator.onLine,
       
      };
    },
    beforeRouteEnter(to, from, next) {
      // return store.fetchSpecial(to.params.slug).then(next)
      next();
    },
    beforeMount() {
      
    },
    beforeDestroy() {
      window.removeEventListener("online", this.updateOnlineStatus);
      window.removeEventListener("offline", this.updateOnlineStatus);
    },
    mounted() {
      window.addEventListener("online", this.updateOnlineStatus);
      window.addEventListener("offline", this.updateOnlineStatus);
      this.fetchGlobalOptions()
 
    },
    computed: {
      navBarItems() {
        return navLists;
      },
      currentNavName() {
        let navName = "";
        let navIndex = this.navBarItems.findIndex((navObj) => {
          return navObj.url == this.$route.path;
        });
        if (navIndex >= 0) {
          navName = this.navBarItems[navIndex].name;
        } else {
          return;
        }
        return navName;
      },
    },
    methods: {
      homePage() {
        this.$router.push("/reports");
      },
      analytictPage() {
        this.$router.push("/AnalyticsSection");
      },
      updateOnlineStatus(e) {
        const { type } = e;
        this.onLine = type === "online";
      },
      fetchGlobalOptions: () => {
    MasterService.GetGlobalOptions().then((response) => {
      const { data } = response;
      console.log("Client_name", data)
      if (data && data.status && data.Records.length > 0) {
         const CLIENT_SETUP_NAME = data.Records.find(
          (go) => go.go_key == "CLIENT_SETUP_NAME"
        );
       console.log("CLIENT_SETUP_NAME",CLIENT_SETUP_NAME)
       localStorage.setItem("setUpName", JSON.stringify(CLIENT_SETUP_NAME.go_value));

      } else {
        console.log("Erro in fetching global options");
      }
    });
  },
    },
  };
</script>
<style>
  .sub_menu p {
    padding-bottom: 5px;
    border-bottom: 1px solid #000;
    font-size: 20px;
  }
  .ham_icon {
    width: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue